import React from "react";
import Select from "react-select";
import { Button } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";

import Logo from "images/logo1.png";
import ChatAibleLogo from "images/Aible_Logo/chataible.svg";

import styles from "./style.module.css";
import { isEnabled } from "utils/featureFlags";

export default class Login extends React.Component {
  state = {
    email: ""
  };

  handleKeyPress(event) {
    const { handlePasswordReset } = this.props;

    if (event.key == "Enter") {
      handlePasswordReset(this.refs.username.value);
    }
  }

  render() {
    const {
      isLoading,
      error,
      tenants,
      selectTenant,
      resetTenants,
      resetMessage,
      handlePasswordReset,
      updateResetMessage,
      history
    } = this.props;

    const hasReset = resetMessage !== undefined;

    // const isLoading = true;

    return (
      <div className={styles.body}>
        <div className={styles.loginBox} style={hasReset ? { paddingBottom: "0px" } : undefined}>
          <div className={styles.loginHeader}>
            <div className={styles.name}>
              <img className={styles.logoImage} src={isEnabled("chat-aible-consumer") ? ChatAibleLogo : Logo} />
            </div>
          </div>
          <div className={styles.loginContent}>
            <div className={styles.header}>{hasReset ? "Password Reset Link Sent" : "Forgot Password?"}</div>
            <div className={styles.message}>{hasReset ? resetMessage : "Reset password in two quick steps"}</div>
            <div className={styles.inputHolder}>
              <div>{hasReset ? "Email you submitted" : "Email:"}</div>
              {/* <input ref="username" className={styles.input} disabled={hasReset}/> */}
              <LineInput
                value={this.state.email}
                onChange={(v) => this.setState({ email: v })}
                isGalleryBox
                isDisabled={hasReset}
                inputStyle={{ fontSize: "13px" }}
              />
            </div>
            {!isLoading && (
              <div className={styles.buttonHolder}>
                {hasReset ? (
                  <Button
                    type="secondary"
                    onClick={() => {
                      updateResetMessage(undefined);
                      return history.push("/login");
                    }}
                    disabled={isLoading === true}
                    className={styles.button}
                  >
                    {"Back to Login"}
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    onClick={() => handlePasswordReset(this.state.email)}
                    disabled={isLoading === true}
                    className={styles.button}
                  >
                    {"Reset Account Password"}
                  </Button>
                )}
              </div>
            )}
            {!hasReset && (
              <div className={styles.newUser}>
                <div className={styles.reset}>
                  <a onClick={() => history.push("/login")}>{"Back to Login"}</a>
                </div>
              </div>
            )}
            {isLoading === true && <LoadingIndicator style={{ marginTop: "20px", marginBottom: "0px" }} />}
          </div>
          <div className={styles.error}>{error}</div>
        </div>
      </div>
    );
  }
}
